import * as React from "react"

type ButtonType = {
  children: React.ReactNode
  type?: "button" | "submit"
  onClick?: () => void
  extraStyle?: string
  disabled?: boolean
}

const Button = ({
  children,
  type,
  onClick,
  disabled,
  extraStyle,
}: ButtonType) => {
  return (
    <button
      type={type ? type : "button"}
      onClick={onClick}
      className={`button-primary ${extraStyle || ""}`}
      disabled={disabled}
    >
      {children}
    </button>
  )
}

export default Button
